import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label:
      'The following questions are to review how your progress has been so far. Please answer honestly and with as much detail as possible!',
    field: 'wl12months',
    type: 'info',
    answer: {}
  },
  {
    label: 'What is your current weight? (In Pounds)',
    type: 'info',
    field: 'wl12monthsWeightNow',
    placeholder: '',
    answer: {
      type: 'number',
      required: true,
      name: 'wl12monthsWeightNowAns'
    }
  },
  {
    label: 'How much weight have you lost? (In Pounds)',
    type: 'info',
    field: 'wl12monthsWeightLoss',
    answer: {
      type: 'number',
      name: 'wl12monthsWeightLossLb'
    }
  },
  {
    label: 'Are you looking to...',
    subLabel: '(Select at least one, or all that apply)',
    field: 'wl12monthsLookingTo',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'maintain', value: 'Maintain my current weight loss' },
        { key: 'transition', value: 'Transition off medications' },
        { key: 'continue', value: 'Continue taking medications' },
        { key: 'increase', value: 'Increase my dose' },
        { key: 'switch', value: 'Switch medications' }
      ]
    }
  },
  {
    field: 'wl12monthsIsEatingConsistentlyAndDrinkingFluids',
    label:
      'Are you eating consistently throughout the day and drinking fluids?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wl12monthsIsEatingConsistentlyAndDrinkingFluidsYes',
          value: 'Yes'
        },
        {
          key: 'wl12monthsIsEatingConsistentlyAndDrinkingFluidsNo',
          value: 'No',
          answer: {
            type: 'text',
            rows: 3,
            name: 'wl12monthsIsEatingConsistentlyAndDrinkingFluidsNoDesc',
            placeholder: 'Please describe'
          }
        }
      ]
    }
  },
  {
    field: 'wl12monthsIsMedicalHealthChange',
    label: 'Have you had any changes to your health status or medication list?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wl12monthsIsMedicalHealthChangeYes',
          value: 'Yes',
          answer: {
            type: 'text',
            rows: 3,
            name: 'wl12monthsIsMedicalHealthChangeYesDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'wl12monthsIsMedicalHealthChangeNo', value: 'No' }
      ]
    }
  },
  {
    label: 'Are you experiencing any of the following',
    subLabel: '',
    field: 'wl12monthsIssues',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'numbness', value: 'Numbness' },
        {
          key: 'tinglingInTheFeet',
          value: 'Tingling in the hands and feet'
        },
        { key: 'recentLossOfHair', value: 'Recent loss of hair' },
        { key: 'brittleNails', value: 'Brittle nails' },
        { key: 'coldHandsAndFeet', value: 'Cold hands and feet' },
        { key: 'fatigue', value: 'Fatigue' },
        { key: 'foggyBrain', value: 'Foggy brain' },
        { key: 'paleSkin', value: 'Pale skin' },
        { key: 'shakiness', value: 'Shakiness' }
      ]
    }
  },
  {
    label: 'Do you track nutrition using an app?',
    field: 'wl12monthsNutritionTrackingApp',
    type: 'file_upload',
    required: false,
    answer: [
      {
        resourceId: 'trackNutritionData',
        buttonLabel: 'Choose file',
        required: false
      }
    ]
  },
  {
    label:
      'Please write what you have had for breakfast lunch and dinner for one day',
    type: 'info',
    field: 'wl12monthsDayDietSample',
    answer: {
      type: 'text',
      rows: 3,
      name: 'wl12monthsDayDietSampleAns'
    }
  }
];

export default questionsModels;
